export const LOAD_TEMPLATE_CONTENT =
  'editorAC/HomePageContainer/LOAD_TEMPLATE_CONTENT';

export const LOAD_TEMPLATE_CONTENT_SUCCESS =
  'editorAC/HomePageContainer/LOAD_TEMPLATE_CONTENT_SUCCESS';

export const SET_IS_OPEN_SIDEBAR_CHOOSE_SIZE =
  'editorAC/HomePageContainer/SET_IS_OPEN_SIDEBAR_CHOOSE_SIZE';

export const listTemplateCategoriesDisplaymmUnit = [
  23,
  38,
  49,
  50,
  53,
  56,
  21,
  24,
  25,
  26,
  28,
  29,
  30,
  31,
  22,
  28,
  29,
  47,
  32,
  43,
  60,
];
